import {takeEvery, all, takeLatest} from 'redux-saga/effects';

import * as lexActionType from '../actionsType/lexDetail.actionType';
import * as lexDetailActionType from '../actionsType/lexCntDetail.actionType';
import * as lexExamActionType from '../actionsType/lexExam.actionType';
import * as lexEnrolledActionType from '../actionsType/lexEnrolled.actionType';
import * as lexFavouriteActionType from '../actionsType/lexFavourite.actionType';
import * as lexLoginActionType from '../actionsType/lexLogin.actionType';
import * as lexLicenseModeActionType from '../actionsType/lexLicenseMode.actionType';
import * as lexGenCopyLinkActionType from '../actionsType/lexGenCopyLink.actionType';
import * as lexLoginDSPActionType from '../actionsType/lexLoginDSP.actionType';
import * as lexCertEnrollAvailCreditActionType from '../actionsType/lexCertEnrollAvailCredit.actionType';
import * as lexRecommandedLearning from '../actionsType/lexRecommandedLearning.actionType';

import {fetchLexDetailSaga} from './lexDetail.saga';
import {fetchLexCntDetailSaga, requestCertVoucherSaga, initKryPreqstSaga, downloadCertSaga} from './lexCntDetail.saga';
import {fetchLexErolledSaga} from './lexEnrolled.saga';
import {fetchaddRemoveFavoriteSaga} from './lexFavourite.saga';
import {loginUserSaga} from './lexLogin.saga';
import {fetchRequestLicenseSaga} from './lexLicenseMode.saga';
import {generateCopyLinkSaga} from './lexGenerateCopyLink.saga';
import {loginDSPSaga} from './lexLoginDSP.saga';
import {lexCertEnrollAvailCreditSaga, lexCertRequestCreditsSaga, lexCertCancelEnrollSaga, lexEnrollmentCodeValidation} from './lexCertEnrollAvailCredit.saga';
import {fetchLexRecommandedLearningSaga} from './lexRecommandedLearning.saga';

// sde19: Action type and saga binding is present here.
// when ever the below action is called automatically the saga is trigged and service is called
export function* fetchLexDetailWatcherSaga() {
    yield takeLatest(lexActionType.FETCH_LEX_DATA, fetchLexDetailSaga);
    yield takeLatest(lexDetailActionType.REQUEST_CERT_VOUCHER, requestCertVoucherSaga);
    yield takeLatest(lexDetailActionType.FETCH_LEX_DETAIL, fetchLexCntDetailSaga);
    yield takeLatest(lexExamActionType.INIT_KRY_PREREQUISITE, initKryPreqstSaga);
    yield takeLatest(lexExamActionType.LEX_EXAM_DOWNLOAD_CERT, downloadCertSaga);
    yield takeLatest(lexEnrolledActionType.FETCH_LEX_ENROLLED, fetchLexErolledSaga);
    yield takeLatest(lexFavouriteActionType.FETCH_LEX_FAVORITE, fetchaddRemoveFavoriteSaga);
    yield takeLatest(lexLoginActionType.LOGIN_USER, loginUserSaga);
    yield takeLatest(lexLoginActionType.TERMS, loginUserSaga);
    yield takeLatest(lexLicenseModeActionType.FETCH_LEX_LICENSE_MODE_REQUEST, fetchRequestLicenseSaga);
    yield takeLatest(lexGenCopyLinkActionType.GENERATE_LEX_LINK, generateCopyLinkSaga);
    yield takeLatest(lexLoginDSPActionType.LEX_LOGIN_DSP, loginDSPSaga);
    yield takeLatest(lexCertEnrollAvailCreditActionType.FETCH_AVAIL_CREDIT, lexCertEnrollAvailCreditSaga);
    yield takeLatest(lexCertEnrollAvailCreditActionType.REQ_CREDIT, lexCertRequestCreditsSaga);
    yield takeLatest(lexCertEnrollAvailCreditActionType.ENROLLMENT_CODE, lexEnrollmentCodeValidation);
    yield takeLatest(lexCertEnrollAvailCreditActionType.CANCEL_ENROLL, lexCertCancelEnrollSaga);
    yield takeLatest(lexRecommandedLearning.FETCH_LEX_RECLEARN, fetchLexRecommandedLearningSaga);
}
